import { render, staticRenderFns } from "./SurveyButton.vue?vue&type=template&id=2cc4af24"
import script from "./SurveyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports